// Copyright 2022, Imprivata, Inc.  All rights reserved.

import classes from './Card.module.css';

export const Card: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => {
  return <div className={classes.card}>{children}</div>;
};
